import DatasetFile from "@/modules/dataset-file";
import { useInterventionSectionDatasetFile } from "@/modules/intervention/intervention-section-datasets";

const InterventionSectionFile = () => {
  const { key, disabled, template, dataset, loading } =
    useInterventionSectionDatasetFile();

  return (
    <DatasetFile
      key={key}
      template={template}
      dataset={dataset}
      loading={loading}
      disabled={disabled}
    />
  );
};

export default InterventionSectionFile;
